import { Component, EventEmitter, inject, OnDestroy, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { subYears } from "date-fns";
import { CONTACT_TITLE_OPTIONS } from "src/app/meta/contact-title-options.const";
import { PATTERNS } from "src/app/meta/patterns.const";
import { ContactPersonService } from "src/app/services/contact-person.service";
import { MaxDateValidator } from "src/app/tools/max-date.validator";

@Component({
    selector: "ow-contact-person-form",
    templateUrl: "./contact-person-form.component.html"
})
export class ContactPersonFormComponent implements OnInit, OnDestroy {

  @Output() updateValidity = new EventEmitter<boolean>(false)
  
  private readonly contactPersonService = inject(ContactPersonService)

  public readonly TITLE_OPTIONS = CONTACT_TITLE_OPTIONS

  public readonly form = new FormGroup({
    title: new FormControl<string>(this.contactPersonService.getContactPerson().title, [Validators.required]),
    firstName: new FormControl<string | null>(this.contactPersonService.getContactPerson().firstName, [
      Validators.required,
      Validators.maxLength(24)
    ]),
    lastName: new FormControl<string | null>(this.contactPersonService.getContactPerson().lastName, [
      Validators.required,
      Validators.maxLength(24)
    ]),
    birthDate: new FormControl<Date | null>(this.contactPersonService.getContactPerson().birthDate, [
      Validators.required,
      MaxDateValidator(subYears(new Date(), 18))
    ]),
    phoneNumber: new FormControl<string | null>(this.contactPersonService.getContactPerson().phoneNumber, [
      Validators.required,
      Validators.pattern(PATTERNS.PHONE_NUMBER)
    ])
  })

  private readonly subscriptions = [
    this.form.controls.title.valueChanges.subscribe((value) => {
      if (this.form.controls.title.valid) {
        this.contactPersonService.setContactPerson({ title: value! })
      }
    }),
    this.form.controls.firstName.valueChanges.subscribe((value) => {
      if (this.form.controls.firstName.valid) {
        this.contactPersonService.setContactPerson({ firstName: value! })
      }
    }),
    this.form.controls.lastName.valueChanges.subscribe((value) => {
      if (this.form.controls.lastName.valid) {
        this.contactPersonService.setContactPerson({ lastName: value! })
      }
    }),
    this.form.controls.birthDate.valueChanges.subscribe((value) => {
      if (this.form.controls.birthDate.valid) {
        this.contactPersonService.setContactPerson({ birthDate: value! })
      }
    }),
    this.form.controls.phoneNumber.valueChanges.subscribe((value) => {
      if (this.form.controls.phoneNumber.valid) {
        this.contactPersonService.setContactPerson({ phoneNumber: value! })
      }
    }),
    this.form.statusChanges.subscribe(() => {
      this.updateValidity.emit(this.form.valid)
    })
  ]

  ngOnInit(): void {
    this.updateValidity.emit(this.form.valid)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }
}
